import { kvRows } from "./PDFKeyValue";
import { PDF_COLORS, pdfFz } from "./stylesPDFv2";

/**
 * Información de pago (zona izquierda del cierre): datos bancarios u otros pares
 * etiqueta/valor. Sin bordes. Encabezado opcional.
 *
 * @param {object} params
 * @param {string} params.titulo  encabezado pequeño opcional (p.ej. "Datos bancarios")
 * @param {Array<{label,value}>} params.rows
 * @returns nodo pdfMake (stack)
 */
export const PDFPaymentInfoV2 = ({ rows = [], titulo } = {}) => ({
  stack: [
    ...(titulo
      ? [{ text: titulo, bold: true, fontSize: pdfFz(8.5), color: PDF_COLORS.ink, margin: [0, 0, 0, 4] }]
      : []),
    ...kvRows(rows, { labelWidth: "32%" }),
  ],
  margin: [0, 0, 8, 0],
});

export default PDFPaymentInfoV2;
